export const DOCUMENTS = "DOCUMENTS";
export const STORE_DOCUMENT_CONTEXT_TEMPLATE = "STORE_DOCUMENT_CONTEXT_TEMPLATE";
export const STORE_DOCUMENT_COMPRESSION_PROGRESS = "STORE_DOCUMENT_COMPRESSION_PROGRESS";

// Mine Alerts
export const STORE_MINE_ALERTS = "STORE_MINE_ALERTS";
export const STORE_GLOBAL_MINE_ALERTS = "STORE_GLOBAL_MINE_ALERTS";
export const CLEAR_MINE_ALERTS = "CLEAR_MINE_ALERTS";
